// Import Configs
import { generateCleanUrlParams } from 'services/Helpers';
import { CRMRequestService, getCancelableRequest, postCancelableRequest } from './http.config';
// Import Types
import { ExclusionRulesListRowData } from 'types';

const ExclusionRulesHttpService = {
    getExclusionRulesSegmentationCategories: () => {
        return getCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/ExclusionRule/GetColumnInfoList',
        });
    },
    getExclusionRulesList: () => {
        return getCancelableRequest<ExclusionRulesListRowData[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/ExclusionRule/List',
        });
    },
    saveExclusionRule: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/ExclusionRule/Create',
        });
    },
    editExclusionRule: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/ExclusionRule/Update',
        });
    },
    deleteExclusionRule: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ exclusionRuleId }) => `/ExclusionRule/Delete?exclusionRuleId=${exclusionRuleId}`,
        });
    },
    archiveExclusionRule: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ exclusionRuleId }) => `/ExclusionRule/Archive?exclusionRuleId=${exclusionRuleId}`,
        });
    },
    unArchiveExclusionRule: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ exclusionRuleId }) => `/ExclusionRule/Unarchive?exclusionRuleId=${exclusionRuleId}`,
        });
    },
    getExclusionRulesById: () => {
        return getCancelableRequest<ExclusionRulesListRowData>({
            requestService: CRMRequestService,
            endpointPath: ({ exclusionRuleId, pointInTime }) =>
                `/ExclusionRule/Get${generateCleanUrlParams({ id: exclusionRuleId, pointInTime })}`,
        });
    },
};

export default ExclusionRulesHttpService;
